export default () => ({
  isError: false,
  isLoading: false,
  trashbin: [],
});
